import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { DecodeResponse } from "../../Models/Response/Redirection/redirection";
import {
  setDecryptedCredential,
  setRedirectIdentifiers,
} from "../../Services/LocalStorageServices";
import { decode } from "../../Services/RedirectionServices/Redirection";
import { QueryParams, Routes } from "../../Utils/Constants/routes";

const Redirection: React.FC = () => {
  const history = useHistory();
  useEffect(() => {
    const queryParam = new URLSearchParams(history.location.search);

    const fi = queryParam.get("fi")?.replace(/\s/g, "+");
    const reqdate = queryParam.get("reqdate");
    const ecreq = queryParam.get("ecreq");

    if (!!fi && !!reqdate && !!ecreq) {
      decode({ fi, ecreq, reqdate })
        .then((res) => res.data)
        .then((res: DecodeResponse) => {
          setDecryptedCredential(res);

          const redirectPath = `/consent/PENDING/${res.srcref}`;
          localStorage.setItem("redirectAfterAccountLink", redirectPath);

          const identifiers: any[] = [];
          if (res.pan != null && res.pan.trim() !== "") {
            identifiers.push({type: "PAN", value: res.pan, categoryType: "WEAK"});
          }
          if (res.dob != null && res.dob.trim() !== "") {
            const dob = new Date(res.dob);
            const formattedDob = `${String(dob.getDate()).padStart(2, "0")}/${String(
              dob.getMonth() + 1
            ).padStart(2, "0")}/${dob.getFullYear()}`;

            identifiers.push({type: "DOB", value: formattedDob, categoryType: "WEAK"});
          }
          // PAN/DOB prefill for account discovery; cleared after discovery, on logout or when stale.
          setRedirectIdentifiers(identifiers);

          if (res.isUserPresent) {
            history.push({
              pathname: Routes.login,
              search: `?${QueryParams.redirect}=/consent/PENDING/${res.srcref}`,
              state: { phoneNumber: res.phoneNumber, fiuID: res.fiuId},
            });
          } else {
            history.push({
              pathname: Routes.signup,
              search: `?${QueryParams.redirect}=/consent/PENDING/${res.srcref}`,
              state: { phoneNumber: res.phoneNumber,  email: res.email ||"",fiuID: res.fiuId, isVuaIdDisabled: true },
            });
          }
        })
        .catch((res: any) => {
          if (!!res.redirectōUrl) {
            window.location.replace(res.redirectUrl);
          }
        });
    }
  }, [history]);

  return <div>Loading...</div>;
};

export default Redirection;
